<script >
import { ref, toRef, watch, onMounted, nextTick } from 'vue-demi';
import useAutoScroll from './useAutoScroll';
const __sfc_main = {};
__sfc_main.props = {
  imgList: Array,
  speed: Number
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const scrollSwiperRef = ref();
  const speed = toRef(props, 'speed');
  const {
    initScroll
  } = useAutoScroll(scrollSwiperRef, speed);

  // 图片列表
  const list = ref([]);
  const init = () => {
    list.value = Object.assign([], props.imgList);
    nextTick(() => initScroll(list));
  };
  watch(() => props.imgList, init);
  onMounted(init);
  return {
    scrollSwiperRef,
    list
  };
};
export default __sfc_main;
</script>
<template>
    <div class="marquee-img-container">
        <div class="scroll-wrapper" ref="scrollSwiperRef">
            <img v-for="(img, i) in list" :key="`${img}_${i}`" class="scroll-item" :src="img.imgUrl" />
        </div>
    </div>
</template>

<style lang="less" scoped>
.marquee-img-container {
    width: 100% !important;
    position: relative;
    .scroll-wrapper {
        height: 100%;
        display: flex;
        -webkit-transition-timing-function: linear;
        -moz-transition-timing-function: linear;
        -ms-transition-timing-function: linear;
        -o-transition-timing-function: linear;
        transition-timing-function: linear;
        transition-property: transform;
        .scroll-item {
            width: auto;
        }
    }
}
</style>
